import { render, staticRenderFns } from "./RoundChart.vue?vue&type=template&id=52cde51b&scoped=true&"
import script from "./RoundChart.vue?vue&type=script&lang=js&"
export * from "./RoundChart.vue?vue&type=script&lang=js&"
import style0 from "./RoundChart.vue?vue&type=style&index=0&id=52cde51b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cde51b",
  null
  
)

export default component.exports